/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invalid_CredentialsInputs */



/**

* @param {Invalid_CredentialsInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const invalid_credentials = /** @type {((inputs?: Invalid_CredentialsInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invalid_CredentialsInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Die Email oder das Passwort sind nicht korrekt.")
});